
import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { StandardOption } from ".";
import { ModelEditableMixin, DisableableMixin } from "../../mixins";

@Component({
})
export default class OptionSelectableMixin extends Mixins(ModelEditableMixin, DisableableMixin) {
  @Prop()
  options: StandardOption<any>[];

  @Prop()
  equivalentValidator: (s: any, d: any) => boolean;

  @Prop()
  filter: (source: any) => boolean;

  get optionFilter(): (source: StandardOption<any>) => boolean {
    return s => s && (!this.filter || this.filter(s.value));
  }

  get filteredOptions(): StandardOption<any>[] {
    return Enumerable.from(this.options)
      .where(this.optionFilter)
      .toArray();
  }

  areEqual(source: any, destination: any): boolean {
    return !this.equivalentValidator
      ? (source === destination)
      : this.equivalentValidator(source, destination);
  }

  findOption(source: any, options: StandardOption<any>[]): StandardOption<any> {
    return Enumerable.from(!options ? [] : options)
      .firstOrDefault(o => this.areEqual(o.value, source));
  }
}
